const initState = {
    departments: [],
    companies: [],
    all_departments: [],
    department_name: null,
    department_id: null,
    department: null,
    company: null,
    policies: [],
    compliances: [],
    actions: [],
    actionsScopeKey: null,
    finding_data: [],
    actions_data: [],
    actionsDataScopeKey: null,
    actionsLoading: false,
    findingsScopeKey: null,
    findingsLoading: false,
    department_dashboard_data: null,
    activeDepartmentId: null,
    notifications_settings: [],
};

const departmentReducer = (state = initState, action) => {

    switch (action.type) {
        case "NOTIFICATIONS_SETTINGS":
            return {
                ...state,
                notifications_settings: action.notifications,
            };

        case "SET_ACTIVE_DEPARTMENT":
            ////console.log("Called", action.department_id)
            return {
                ...state,
                activeDepartmentId: action.department_id,
            };

        case "OPEN_DEPARTMENT_DASHBOARD": 
            return {
                ...state,
                department_dashboard_data: action.department_id,
            };

        case "RESET_DEPARTMENT_DASHBOARD":
            return {
                ...state,
                department_dashboard_data: null,
            };

        case "ACTIONS_REQUEST": {
            const nextKey = `dept:${action.department_id ?? 0}`;
            const isScopeChange = nextKey !== state.actionsScopeKey;
            return {
                ...state,
                actions: isScopeChange ? [] : state.actions,
                actionsScopeKey: nextKey,
            };
        }

        case "ACTIONS":
            if (
                action.scopeKey != null &&
                state.actionsScopeKey != null &&
                action.scopeKey !== state.actionsScopeKey
            ) {
                return state;
            }
            return {
                ...state,
                actions: action.actions,
                actionsScopeKey: action.scopeKey ?? state.actionsScopeKey,
            };
        case "ACTIONS_DATA_REQUEST": {
            const nextKey = `dept:${action.department_id ?? 0}`;
            const isScopeChange = nextKey !== state.actionsDataScopeKey;
            return {
                ...state,
                actions_data: isScopeChange ? [] : state.actions_data,
                actionsDataScopeKey: nextKey,
                actionsLoading: true,
            };
        }

        case "ACTIONS_DATA":
            if (
                action.scopeKey != null &&
                state.actionsDataScopeKey != null &&
                action.scopeKey !== state.actionsDataScopeKey
            ) {
                return state;
            }
            return {
                ...state,
                actions_data: action.actions,
                actionsDataScopeKey: action.scopeKey ?? state.actionsDataScopeKey,
                actionsLoading: false,
            };
        case "ACTIONS_DATA_FETCH_FAILED":
            return {
                ...state,
                actionsLoading: false,
            };
        case "FINDINGS_REQUEST": {
            const nextKey = `dept:${action.department_id ?? 0}`;
            const isScopeChange = nextKey !== state.findingsScopeKey;
            return {
                ...state,
                finding_data: isScopeChange ? [] : state.finding_data,
                findingsScopeKey: nextKey,
                findingsLoading: true,
            };
        }
        case "FINDINGS_DATA":
            if (action.scopeKey != null && !String(action.scopeKey).startsWith("dept:")) {
                return state;
            }
            if (
                action.scopeKey != null &&
                state.findingsScopeKey != null &&
                action.scopeKey !== state.findingsScopeKey
            ) {
                return state;
            }
            return {
                ...state,
                finding_data: action.findings,
                findingsScopeKey: action.scopeKey ?? state.findingsScopeKey,
                findingsLoading: false,
            };
        case "FINDINGS_FETCH_FAILED":
            return {
                ...state,
                findingsLoading: false,
            };
        case "POLICIES":
            ////console.log("action ", action)
            return {
                ...state,
                departments: action.departments,
            };

        case "POLICIES_GET":
            //console.log("action ", action)
            return {
                ...state,
                departments: action.departments,
                compliances: action.compliances,
            };

        case "UPDATE_DEPARTMENT":
            return {
                ...state,
                department: action.department,
            };
        case "ALL_DEPARTMENTS":
            return {
                ...state,
                all_departments: action.all_departments,
            };


        case "RESET_DEPARTMENT":
            return {
                ...state,
                department_id: null,
            };
        case "DEPARTMENT_NAME":
            return {
                ...state,
                department_name: action.department_name,
            };

        case "OPEN_DEPARTMENT":
            ////console.log("Opening ",action.department_id)
            return {
                ...state,
                department_id: action.department_id,
            };

        case "DEPARTMENTS":
            return {
                ...state,
                departments: action.departments,
            };

        case "COMPANIES":
            return {
                ...state,
                companies: action.companies,
            };

        case "COMPANY":
            return {
                ...state,
                company: action.company,
            };

        case "RESET_NEWLYCREATED_DEPARTMENT_ID":
            return {
                ...state,
                newlycreatedDepartmentId: null,
            };
        
        case "RESET_NEWLYCREATED_COMPANY_ID":
            return {
                ...state,
                newlyCreatedCompanyId: null,
                company: null,
            };

        case "DEPARTMENT_CREATED":
            return {
                ...state,
                departments: action.departments,
                newlycreatedDepartmentId: action.newlycreatedDepartmentId,
            };

        case "COMPANY_CREATED":
            ////console.log("Compmay created")
            return {
                ...state,
                companies: action.companies,
                newlyCreatedCompanyId: action.newlyCreatedCompanyId,
            };

        default:
            return state;
    }
};

export default departmentReducer;
